/**
 * Extracts the return_to parameter from the current URL's query string
 * @returns The return_to value if present, otherwise null
 */
export const getReturnToParam = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const returnTo = urlParams.get('return_to');
  return returnTo ? decodeURIComponent(returnTo) : null;
};
